export const EMPTY_PLAYER = {lastname : '...', firstname : '...', number : 0, numero : 0}